import TableToolbar from '@rio-cloud/rio-uikit/TableToolbar';
import { FunctionComponent, ReactNode } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../configuration/setup/hooks';
import { compoundManagementSlice, getActiveCompoundManagementView } from '../../../reducers/compoundManagementSlice';
import { CompoundManagementViewSelection } from './CompoundManagementViewSelection';
import { CompoundManagementView } from '../../compoundManagement.types';
import { CompoundManagementVinSearch } from './CompoundManagementVinSearch';
import { CompoundManagementFilterModal } from './CompoundManagementFilterModal';
import { CompoundVehiclesExportModal } from './CompoundVehiclesExportModal';
import { TableColumnSettings } from '../../../sharedComponents/table/TableColumnSettings';
import { TableViewOptions } from '../../../sharedComponents/TableViewOptions';

export type CompoundManagementToolbarProps = {
    bulkActionButton?: ReactNode;
};

export const CompoundManagementToolbar: FunctionComponent<CompoundManagementToolbarProps> = ({ bulkActionButton }) => {
    const view = useAppSelector(getActiveCompoundManagementView);
    const dispatch = useAppDispatch();

    const handleSwitchView = (newView: CompoundManagementView) => {
        dispatch(compoundManagementSlice.actions.switchView(newView));
    };

    return (
        <TableToolbar>
            <div className="table-toolbar-container">
                <div className="table-toolbar-group-left">
                    <div className="table-toolbar-column">
                        <div className="btn-toolbar table-btn-toolbar">
                            <CompoundManagementViewSelection activeView={view} setActiveView={handleSwitchView} />
                        </div>
                    </div>
                </div>
                <div className="table-toolbar-group-right">
                    {bulkActionButton && (
                        <div className="table-toolbar-column table-toolbar-column-spacer">{bulkActionButton}</div>
                    )}
                    <div className="table-toolbar-column">
                        <CompoundManagementFilterModal modalType={view} />
                    </div>
                    <div className="table-toolbar-column">
                        <CompoundManagementVinSearch />
                    </div>
                    <div className="table-toolbar-column">
                        <CompoundVehiclesExportModal />
                    </div>
                    <div className="table-toolbar-column">
                        <TableViewOptions />
                    </div>
                    <div className="table-toolbar-column">
                        <TableColumnSettings />
                    </div>
                </div>
            </div>
        </TableToolbar>
    );
};
